export const GET_TEST_SET_ENTRIES_REQUEST = 'GET_TEST_SET_ENTRIES_REQUEST';
export const GET_TEST_SET_ENTRIES_SUCCESS = 'GET_TEST_SET_ENTRIES_SUCCESS';
export const GET_TEST_SET_ENTRIES_ERROR = 'GET_TEST_SET_ENTRIES_ERROR';
export const ADD_TEST_SET_ENTRY_REQUEST = 'ADD_TEST_SET_ENTRY_REQUEST';
export const ADD_TEST_SET_ENTRY_SUCCESS = 'ADD_TEST_SET_ENTRY_SUCCESS';
export const ADD_TEST_SET_ENTRY_ERROR = 'ADD_TEST_SET_ENTRY_ERROR';
export const UPDATE_TEST_SET_ENTRY_REQUEST = 'UPDATE_TEST_SET_ENTRY_REQUEST';
export const UPDATE_TEST_SET_ENTRY_SUCCESS = 'UPDATE_TEST_SET_ENTRY_SUCCESS';
export const UPDATE_TEST_SET_ENTRY_ERROR = 'UPDATE_TEST_SET_ENTRY_ERROR';
export const DELETE_TEST_SET_ENTRY_REQUEST = 'DELETE_TEST_SET_ENTRY_REQUEST';
export const DELETE_TEST_SET_ENTRY_SUCCESS = 'DELETE_TEST_SET_ENTRY_SUCCESS';
export const DELETE_TEST_SET_ENTRY_ERROR = 'DELETE_TEST_SET_ENTRY_ERROR';
export const DELETE_TEST_SET_ENTRIES_REQUEST =
  'DELETE_TEST_SET_ENTRIES_REQUEST';
export const DELETE_TEST_SET_ENTRIES_SUCCESS =
  'DELETE_TEST_SET_ENTRIES_SUCCESS';
export const DELETE_TEST_SET_ENTRIES_ERROR = 'DELETE_TEST_SET_ENTRIES_ERROR';
export const UPDATE_TEST_SET_ENTRIES_PAGINATION_PARAMS =
  'UPDATE_TEST_SET_ENTRIES_PAGINATION_PARAMS';
export const UPDATE_SELECTED_ENTRIES = 'UPDATE_SELECTED_ENTRIES';
export const UPDATE_TEST_SET_ENTRIES = 'UPDATE_TEST_SET_ENTRIES';
